<template>
	<div>
		<div class="header-fix">
			<div class="flex align-center header-main">
				<div class="flex align-center header-logo">
					<div class="menu-toggle" @click="toggleSidebar">
						<i class="el-icon-s-unfold"></i>
					</div>
					<div class="page-title">{{siteCfg ? siteCfg.webtool_login_desc : 'PC转链工具'}}</div>
				</div>
				<div class="header-user">
					<div class="flex user-info">
						<div class="flex align-center">
							<div class="avatar m-r-10" v-if="userInfo.avatar">
								<img :src="userInfo.avatar" alt="">
							</div>
							<div class="user-detail">
								<div class="flex name align-center">
									<span class="color3 bold">{{ isSubAccount ? userInfo.sub_account_info.username : userInfo.nickname }}</span>
									<div class="level" v-if="userInfo.level_icon">
										<el-tooltip :content="userInfo.agent_name" placement="top" effect="light">
											<div class="icon m-l-5">
												<img :src="userInfo.level_icon" class="icon-img" alt="">
											</div>
										</el-tooltip>
									</div>
								</div>
								<div class="id color9 font12" v-if="!isSubAccount">手机号：{{ userInfo.mobile }}</div>
							</div>
						</div>
						<div class="m-l-30">
							<el-button type="default" @click="handleLogout" class="transUrlbtn" :loading="logoutLoading"
								size="mini">退出登录</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
import { userLogout } from '@/api/public'
import { markManualLogout } from '@/utils/auth'
export default {
	name: 'HeaderIndex',
	data() {
		return {
			isWhiteBg: false,
			opacityStyle: {
				background: 'transparent'
			},
			drawer: false,
            transH5url: '',
			logoutLoading: false
		}
	},
	computed: {
		userInfo() {
			return this.$store.getters.info
		},
		isSubAccount() {
			return this.userInfo.sub_account_info && this.userInfo.sub_account_info.username
		},
		siteCfg() {
			return this.$store.getters.config
		}
	},
	mounted() {
	},
	methods: {
		handleLogout() {
			if (this.logoutLoading) return
			this.logoutLoading = true
			markManualLogout()
			userLogout().catch(() => {}).finally(() => {
				this.$store.dispatch('user/logout').then(() => {
					this.$message.success('账号已退出')
					this.$router.replace(`/login`)
					this.logoutLoading = false
				})
			})
		},
		
		// 切换侧边栏显示/隐藏
		toggleSidebar() {
			this.$emit('toggle-sidebar')
		}
	}
}
</script>

<style lang="scss" scoped>
img {
	display: block;
	width: 100%;
}   
.header-fix {
	width: 100%;
	height: 60px;
	padding: 0 40px 0 240px; /* 左边留出侧边栏的空间 */
	background: #fff;
	box-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
	z-index: 1000;
	position: fixed;
	top: 0;
	left: 0;
	
	.header-main {
		height: 100%;
		justify-content: space-between;
		
		.header-logo {
			.menu-toggle {
				display: none;
				width: 32px;
				height: 32px;
				text-align: center;
				line-height: 32px;
				margin-right: 12px;
				background: #f5f7fa;
				border-radius: 6px;
				cursor: pointer;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				
				&:hover {
					background: #e6e8eb;
				}
				
				i {
					font-size: 18px;
					color: #606266;
				}
			}
			
			.page-title {
				font-size: 18px;
				font-weight: 600;
				color: #303133;
			}
		}
		.header-user {
			.user-info {
				align-items: center;
				.avatar {
					width: 38px;
					height: 38px;
					border-radius: 100%;
					overflow: hidden;
				}
				.user-detail {
				}
				.level {
					align-self: flex-start;
					.icon {
							
							height: 20px;
							// cursor: pointer;
							&-img {
								height: 100%;
							}
						}
				}
			}
		}
		.login-btn {
			padding: 10px 20px;
			color: #f2f2f2;
			border-radius: 20px;
			border: 1px solid #f2f2f2;
			cursor: pointer;
			&.gary {
				color: #666;
				border-color: #666;
			}
		}
	}
}

// 响应式设计
@media (max-width: 768px) {
	.header-fix {
		padding: 0 20px 0 200px;
		
		.header-logo {
			.menu-toggle {
				display: block!important;
			}
		}

		.page-title {
			display: none;
		}
	}
}

@media (max-width: 576px) {
	.header-fix {
		padding: 0 20px;
		
		.header-logo {
			.menu-toggle {
				display: block!important;
			}
		}
		
		.page-title {
			display: none;
		}
	}
}
</style>
